import { PROJECTS_TAG } from '../../../../data/actions';

export const DATA_EXTRACTION_FILE_TYPES = 'DATA_EXTRACTION_FILE_TYPES';

/**
 * Sets the Signal Types
 * @param signalTypes
 * @returns {{type: string, signalTypes: *}}
 */
export const setDataFileTypes = fileTypes => {
  return {
    type: DATA_EXTRACTION_FILE_TYPES,
    fileTypes
  };
};

/**
 * Gets the various Signal Types with their dimensions, hardware, software & versions.
 */
export const getProjectFileTypes = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(PROJECTS_TAG, 'getProjectFileTypes', { projectId });

    const fileTypes = results.data.map(fileType => {
      const fileColumns = fileType.signals.map(signal => {
        return {
          id: signal.id,
          name: signal.name,
          data_acquisition_id: signal.data_acquisition_id,
          type: 'signal'
        };
      });

      if (fileType.occurrences.length > 0) {
        fileColumns.push({
          ids: fileType.occurrences.map(occurrence => {
            return occurrence.id;
          }),
          name: 'Events',
          type: 'occurrence'
        });
      }

      return {
        id: fileType.id,
        name: fileType.label,
        abstract_types: fileColumns
      };
    });

    await dispatch(setDataFileTypes(fileTypes));

    return true;
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/dataFilesActions.js